import { Flex, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import { OptionEntity } from '@/types/OptionEntity';
import { useDevices } from '@/utils/devices';

import BaseClickable from '../BaseClickable';

import s from './NoteTabs.module.scss';

export type NoteTabData = OptionEntity & {
  disabled?: boolean;
};

export type Props = {
  items: NoteTabData[];
  activeKey: string | null;
  onChange: (key: string) => void;
};

const NoteTabs: React.FC<Props> = ({ items, activeKey, onChange }) => {
  const { isCompactViewport } = useDevices();

  return (
    <Flex className={s.root} align="center">
      {items.map((item) => {
        const isActive = activeKey === item.key;

        return (
          <BaseClickable
            withHover
            disabled={item.disabled}
            className={cn(s.root__tab, isActive && s.root__tab_active, item.disabled && s.root__tab_disabled)}
            key={item.key}
            onClickWithValue={onChange}
            value={item.key}
          >
            <Text size={isCompactViewport ? 'xs' : 'sm'} fw={isCompactViewport ? 600 : 400}>
              {item.value}
            </Text>
          </BaseClickable>
        );
      })}
    </Flex>
  );
};

export default React.memo(NoteTabs);
